function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M61,27H59.841C57.386,13.505,44.18,2.607,29.412,2.025,29.279,2.012,29.133,2,29,2a4,4,0,1,0,3.955,4.442C38.712,10.752,42.09,17.878,42.09,26c0,.339-.011.676-.027,1H41a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h1.689A24.108,24.108,0,0,1,38.5,41H29a1,1,0,0,0-.895,1.447l2.559,5.116A24.713,24.713,0,0,1,20,50,22.674,22.674,0,0,1,3.7,43.284a1,1,0,0,0-1.61,1.127A29.293,29.293,0,0,0,29,62,30.031,30.031,0,0,0,58.975,33H61a1,1,0,0,0,1-1V28A1,1,0,0,0,61,27ZM29,8a2,2,0,1,1,2-2A2,2,0,0,1,29,8Zm24.66,9.339a26.887,26.887,0,0,1,2.824,5.249A2.946,2.946,0,0,1,55,23a2.986,2.986,0,0,1-1.34-5.661ZM33.753,4.532a31.768,31.768,0,0,1,18.7,11.2,4.97,4.97,0,0,0,4.7,8.753A23.975,23.975,0,0,1,57.813,27H44.065c.015-.322.025-.659.025-1a30.353,30.353,0,0,0-.319-4.343A4.989,4.989,0,0,0,42,12a4.789,4.789,0,0,0-1.391.216A23.715,23.715,0,0,0,33.753,4.532Zm7.791,9.526A2.845,2.845,0,0,1,42,14a3,3,0,0,1,3,3,2.967,2.967,0,0,1-1.589,2.631A26.983,26.983,0,0,0,41.544,14.058ZM29,60A27.134,27.134,0,0,1,6.384,48.011,24.347,24.347,0,0,0,20,52a26.852,26.852,0,0,0,7.345-1.052,7.594,7.594,0,0,0,7.069,3.889,15.558,15.558,0,0,0,4.9-.888l-.632-1.9c-6.206,2.067-8.624-.46-9.41-1.731a24.949,24.949,0,0,0,3.2-1.441,1,1,0,0,0,.418-1.326L30.618,43h8.364a1,1,0,0,0,.774-.366A26.123,26.123,0,0,0,44.771,33H56.982A28.034,28.034,0,0,1,29,60ZM60,31H42V29H60Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M49,45a5.006,5.006,0,0,0,5-5H52a3,3,0,0,1-6,0H44A5.006,5.006,0,0,0,49,45Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.076,41.383A1,1,0,0,0,15,42h5a1,1,0,0,0,0-2H17.414l3.293-3.293A1,1,0,0,0,20,35H15a1,1,0,0,0,0,2h2.586l-3.293,3.293A1,1,0,0,0,14.076,41.383Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M33.924,24.617A1,1,0,0,0,33,24H27a1,1,0,0,0,0,2h3.586l-4.293,4.293A1,1,0,0,0,27,32h6a1,1,0,0,0,0-2H29.414l4.293-4.293A1,1,0,0,0,33.924,24.617Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14,14h5.586l-6.293,6.293A1,1,0,0,0,14,22h8a1,1,0,0,0,0-2H16.414l6.293-6.293A1,1,0,0,0,22,12H14a1,1,0,0,0,0,2Z"
});

var SvgMoon = function SvgMoon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Filled_outline",
    "data-name": "Filled outline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.087,26c0,.674-.035,1.339-.087,2H59C56.965,14.153,43.27,3.415,29,3,37.905,6.825,43.087,15.694,43.087,26Z",
    style: {
      fill: "#d9176c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 6,
    r: 3,
    style: {
      fill: "#9b1e5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,32a25.315,25.315,0,0,1-5.018,10H29l3,6a25.682,25.682,0,0,1-12,3A23.773,23.773,0,0,1,3,44,28.276,28.276,0,0,0,29,61,29,29,0,0,0,58,32Z",
    style: {
      fill: "#f9bb4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,45a5.006,5.006,0,0,1-5-5h2a3,3,0,0,0,6,0h2A5.006,5.006,0,0,1,49,45Z",
    style: {
      fill: "#394d5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.414,54.837c-5.774,0-7.344-4.465-7.363-4.521l1.9-.64c.072.206,1.856,5,9.738,2.375l.632,1.9A15.558,15.558,0,0,1,34.414,54.837Z",
    style: {
      fill: "#394d5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.007,16.139a3.991,3.991,0,1,0,3.692,6.8A27.719,27.719,0,0,0,54.007,16.139Z",
    style: {
      fill: "#eb8cb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.64,20.935a3.991,3.991,0,1,0-2.48-7.467A26.035,26.035,0,0,1,42.64,20.935Z",
    style: {
      fill: "#eb8cb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,42H15a1,1,0,0,1-.707-1.707L17.586,37H15a1,1,0,0,1,0-2h5a1,1,0,0,1,.707,1.707L17.414,40H20a1,1,0,0,1,0,2Z",
    style: {
      fill: "#7fcac9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,32H27a1,1,0,0,1-.707-1.707L30.586,26H27a1,1,0,0,1,0-2h6a1,1,0,0,1,.707,1.707L29.414,30H33a1,1,0,0,1,0,2Z",
    style: {
      fill: "#7fcac9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,22H14a1,1,0,0,1-.707-1.707L19.586,14H14a1,1,0,0,1,0-2h8a1,1,0,0,1,.707,1.707L16.414,20H22a1,1,0,0,1,0,2Z",
    style: {
      fill: "#7fcac9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 28,
    width: 20,
    height: 4,
    style: {
      fill: "#6f1d48"
    }
  }), _ref2, _ref3, _ref4, _ref5, _ref6));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/moon.25e91ac6.svg";
export { ForwardRef as ReactComponent };